module.exports = __webpack_public_path__ + "static/img/fpxx.af7106f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fpxx.jpg
// module id = HktF
// module chunks = 4